export const CONTRACT_TYPES = [
  {
    value: "permanent",
    label: "Dauercamper",
    description: "Vertrag über einen Dauerstellplatz.",
    pitchUsageType: "permanent",
  },
  {
    value: "storage",
    label: "Abstellplatz",
    description: "Vertrag über einen Abstellplatz.",
    pitchUsageType: "storage",
  },
] as const;

export type ContractTypeValue = (typeof CONTRACT_TYPES)[number]["value"];

export function contractTypeLabel(value: string | null | undefined): string {
  if (!value) return "—";
  return CONTRACT_TYPES.find((t) => t.value === value)?.label ?? value;
}

export function pitchUsageTypeForContractType(contractType: ContractTypeValue): string {
  return (
    CONTRACT_TYPES.find((t) => t.value === contractType)?.pitchUsageType ?? "permanent"
  );
}
